export type HnpUploadTab =
  | 'nursing'
  | 'therapy'
  | 'pt'
  | 'ot'
  | 'st'
  | 'misc'
  | 'orders';

/**
 * Tab names for H&P document uploads in Kinnser.
 */
/**
 * Array of all HnpUploadTab values.
 * Tab names for H&P document uploads in Kinnser.
 */
export const HNPUPLOADTAB_VALUES: readonly HnpUploadTab[] = [
  'nursing',
  'therapy',
  'pt',
  'ot',
  'st',
  'misc',
  'orders',
] as const;
